import { create } from 'zustand';

interface SplashState {
  splashComplete: boolean;
  markComplete: () => void;
}

export const useSplashStore = create<SplashState>((set) => ({
  splashComplete: false,
  markComplete: () => set({ splashComplete: true }),
}));
